import { EColors, userClaimTypes } from "src/helpers/utils";
import styled, { css } from "styled-components";

const Container = styled.div`
  width: min(400px, 100%);
  
  .MuiAccordionSummary-root {
    .Mui-expanded {
      .accordion-summary-chips {
        visibility: hidden !important;
        opacity: 0 !important;
        position: absolute;
        top: 30px;
      }
    }
  }
`;

const AccordionDetail = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 5px;

  .select-all-button {
    display: block;
    background-color: transparent;
    text-transform: inherit;
    box-shadow: none;
    color: black;
    min-width: auto !important;
    min-height: auto !important;
    height: fit-content;
    padding-right: 2px;

    :hover, :focus {
      background-color: transparent;
      box-shadow: none;
      text-decoration: underline;
    }
  }
  
  .form-control_values {
    flex-grow: 1;
  }

  .MuiFormGroup-root {
    border: 1px solid ${({ theme }) => theme.brand.line};
    border-radius: 5px;
    padding-left: 10px;
    width: 100%;
    min-height: 150px;
    height: 150px;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0;
    overflow: auto;

    &.Mui-error {
      border: 1px solid red !important;
    }
  }
`;

const Label = styled.span<{ color?: EColors }>`
  padding: 2px 16px;
  border-radius: 50px;

  ${(props) => {
    let cssStyles = css``;

    switch (props.color) {
      case EColors.DEFAULT:
        cssStyles = css`
          background-color: ${userClaimTypes.defaultClaim.color};
          color: white;
        `;
        break;
      case EColors.SUCCESS:
        cssStyles = css`
          background-color: ${userClaimTypes.additionalUserClaim.color} !important;
          color: black !important;
        `;
        break;
      case EColors.WARNING:
        cssStyles = css`
          background-color: ${userClaimTypes.restrictedUserClaim.color} !important;
          color: ${props.theme.brand.navy} !important;
        `;
        break;
      default:
        break;
    }

    return cssStyles;
  }}
`;

const SyncLoader = {
  "align-self": "center",
  "margin": "auto"
};

export { Container, AccordionDetail, Label, SyncLoader };